export default "__VITE_ASSET__BshWfoHR__ 1920w";